export const ENABLE_NOTIFICATION_ENDPOINTS = {
  "/profile/demo": {
    allowMethod: ["POST"],
    defaultMsg: "Demo profile mode have been changed",
    successMsg: "Demo profile mode have been changed successfully",
    errorMsg: "Failed to change demo profile",
  },
  "/apikeys": {
    allowMethod: ["POST"],
    defaultMsg: "API key created",
    successMsg: "API key created successfully",
    errorMsg: "Failed to create API key",
  },
  "/import/file/transactions": {
    allowMethod: ["POST"],
    defaultMsg: "Transactions imported",
    successMsg: "Transactions imported successfully",
    errorMsg: "Failed to import transactions",
  },
  "/transaction": {
    allowMethod: ["POST", "DELETE", "UPDATE"],
    defaultMsg: "Transaction added",
    successMsg: "Transaction added successfully",
    errorMsg: "Failed to add transaction",
  },
  "/tax/setting": {
    allowMethod: ["POST"],
    defaultMsg: "Tax setting updated",
    successMsg: "Tax setting updated successfully",
    errorMsg: "Failed to update tax setting",
  },
  "/sync": {
    allowMethod: ["POST"],
    defaultMsg: "Sync process has been started. Wait a minute",
    successMsg: "Sync process has been started. Wait a minute",
    errorMsg: "Failed to trigger sync. Please try again later",
  },
};

export const findNotificationConfigByUrl = (url: string) => {
  let matchedKey = Object.keys(ENABLE_NOTIFICATION_ENDPOINTS).find((key) => {
    if (key === "/sync") return url.startsWith("/sync");
    return key === url;
  });

  if (matchedKey) {
    const config = ENABLE_NOTIFICATION_ENDPOINTS[matchedKey];
    return config;
  }
};
